import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, message, Row, Icon } from 'antd';
import cx from 'classnames';
import $$ from 'cmn-utils';
import './style/index.less';
import stylesDark from './stylesDark.module.less';
import stylesLight from './stylesLight.module.less';

const createForm = Form.create;
const PlainComp = ({ className, children }) => (
    <div className={className}>{children}</div>
);
PlainComp.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};


/**
 * 搜索条
 */
class SearchBar extends React.Component {
    state = {
        visible: false,
        type: `inline`,
    }



    static propTypes = {
        prefixCls: PropTypes.string,
        className: PropTypes.string,
        /**
         * 详见帮助文档 column.js 用法
         */
        columns: PropTypes.array.isRequired,
        /**
         * 使用record的数据对表单进行赋值 {key:value, key1: value1}, 时间类型初始值需转成moment类型
         */
        record: PropTypes.object,
        /**
         * 搜索条类型 inline(行内)，grid(栅格)
         */
        type: PropTypes.string,
        /**
         * 搜索条件分组，设置这个属性后，会在column.js中过滤有相同group值的搜索项
         */
        group: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        /**
         * 同antd中Grid组件中的Row配置
         */
        rows: PropTypes.object,

        /**
         * 额外搜索项
         */
        children: PropTypes.node,
        /**
         * 如何处理表单里带弹出框的项，比如下拉框，下拉树，日期选择等
         * 设置为true会自动依附到form上，或用function自已指定
         * 用法见antd带弹窗组件的getPopupContainer属性http://ant-design.gitee.io/components/select-cn/
         * appendTo={triggerNode => triggerNode.parentNode}
         */
        appendTo: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),

        form: PropTypes.object,

        /**
         * 点击查询按钮 onSearch(values, isReset) values 查询数据 isReset 是否是重置
         */
        onSearch: PropTypes.func
    };

    static defaultProps = {
        prefixCls: 'antui-searchbar',
        type: 'inline'
    };

    // 内联元素默认宽
    width = {
        date: 100,
        month: 100,
        'date~': 280,
        datetime: 140,
        select: 180,
        default: 110,
        treeSelect: 110,
        cascade: 110,
        cascader: 110
    };

    // 当type为grid时，指定每两个元素的间隔
    rows = {
        gutter: 8
    };

    resetForm(e) {
        this.props.form.resetFields();
        this.searchForm(true);
    }

    visibleChange = () => {
        const { visibleChange } = this.props;
        let visible = !this.state.visible;
        this.setState({ visible, type: visible ? `grid` : `inline` });
    }

    searchForm(isReset) {
        this.props.form.validateFields((errors, values) => {
            if (errors) {
                let errs = [];
                Object.keys(errors).forEach(fieldName => {
                    errs = errors[fieldName].errors || [];
                });
                if (errs && errs.length) message.error(errs[0].message);
                return;
            }

            this.props.onSearch && this.props.onSearch(values, isReset);
        });
    }

    render() {
        const {
            theme,
            className,
            prefixCls,
            appendLeft,
            rows,
            columns,
            form,
            appendTo,
            record, buttons,
            getPopupContainer: parPopupContainer,
            ...otherProps
        } = this.props;

        let styles = theme === `light` ? stylesLight : stylesDark;
        const { visible, type } = this.state;

        const colopts = {};
        const rowopts = type === 'grid' ? rows || this.rows : {};

        let ComponentRow = type === 'inline' ? PlainComp : Row;
        let ComponentCol = type === 'inline' ? PlainComp : Col;
        let ComponentItem = type === 'inline' ? PlainComp : Form.Item;

        let ComponentBtnGroup = type === 'inline' ? Button.Group : PlainComp;

        let searchFields = columns.filter(col => col.searchItem);
        searchFields = type === 'inline'
            ? searchFields.filter(
                col => col.searchItem && col.searchItem.group === `mini`
            )
            : searchFields;


        delete otherProps.onSearch;

        let getPopupContainer = null;
        if (appendTo) {
            if ($$.isFunction(appendTo)) getPopupContainer = appendTo;
            else if (appendTo === true)
                getPopupContainer = triggerNode => triggerNode.parentNode;
            else getPopupContainer = _ => appendTo;
        }
        let buttonPar = {
            className: type === 'grid' ? styles.buttonGrid : styles.button,
            type: type === 'grid' ? 'primary' : 'default'
        }
        let formInfo = (
            <Form className={cx({ 'form-inline': type === 'inline', 'form-grid': type === 'grid', }, styles.form)}>
                <ComponentRow className="row-item" {...rowopts}>
                    {searchFields.map((field, i) => {
                        let col = { ...colopts };
                        if (type === 'grid' && field.searchItem.col) {
                            col = field.searchItem.col;
                        } else if (type !== 'grid') {
                            col = {};
                        }

                        const fieldType = field.searchItem.type || 'input';

                        const formProps = {
                            form,
                            name: field.name,
                            title: field.title,
                            record,
                            ...field.searchItem
                        };

                        if (type === 'inline') {
                            formProps.style = {
                                width: formProps.width || this.width[fieldType]
                            };
                        }

                        if (getPopupContainer) {
                            formProps.getPopupContainer = getPopupContainer;
                        }

                        if (field.dict) {
                            formProps.dict = field.dict;
                        }

                        let FieldComp;
                        switch (fieldType) {
                            case 'date~': // 日期范围
                            case 'datetime': // 日期时间
                            case 'date': // 日期
                            case 'month': // 月
                            case 'time': // 时间
                                FieldComp = require(`../Form/model/date`).default(formProps);
                                break;
                            case 'input': // 输入框
                            case 'textarea': // 多行文本
                                formProps.formFieldOptions = {
                                    rules: [
                                        {
                                            pattern: /^[^'%&<>=?*!]*$/,
                                            message: '查询条件中不能包含特殊字符'
                                        }
                                    ]
                                };
                                formProps.maxLength = field.searchItem.maxLength || 100;
                                formProps.autoComplete = 'off';
                                FieldComp = require(`../Form/model/input`).default(formProps);
                                break;
                            case 'hidden': // 隐藏域
                                return (
                                    <span key={`col-${i}`}>
                                        {require(`../Form/model/input`).default(formProps)}
                                    </span>
                                );
                            case 'select':
                                if (type === 'grid') {
                                    if (!formProps.style) formProps.style = {};
                                    formProps.style.width = `100%`;
                                }
                                formProps.showSearch = true
                                formProps.optionFilterProp = "children"
                                formProps.filterOption = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                formProps.optionFilterProp = 'children';
                            // eslint-disable-next-line no-fallthrough
                            case 'treeSelect':
                                formProps.treeNodeFilterProp = 'title';
                            case 'cascade':
                                formProps.allowClear = true;
                                formProps.showSearch = true;
                            // eslint-disable-next-line no-fallthrough
                            default:
                                // 通用
                                FieldComp = require(`../Form/model/${fieldType.toLowerCase()}`).default(
                                    formProps
                                );
                        }

                        return (
                            <ComponentCol key={`col-${i}`} className="col-item" {...col}>
                                <ComponentItem
                                    // label={<span style={{color:'rgba(0,0,0,0.85',fontSize:'0.146rem'}}>{field.title}:</span>}
                                    label={field.title}
                                    className="col-item-content"
                                >
                                    {FieldComp}
                                </ComponentItem>
                            </ComponentCol>
                        );
                    })}
                    <ComponentCol className="col-item"  >
                        <ComponentItem
                            label={' '} colon={false}
                            className="col-item-content"
                        >
                            <ComponentBtnGroup className="search-btns">
                                <Button
                                    {...buttonPar}
                                    title="查询"
                                    onClick={e => this.searchForm()}
                                    htmlType="submit"
                                    icon="search"
                                >
                                    查询
                                 </Button>
                                <Button
                                    {...buttonPar}
                                    title={visible ? `隐藏` : `展开`} onClick={e => this.visibleChange()} icon={visible ? `up` : `down`}>
                                    {visible ? `隐藏` : `展开`}
                                </Button>
                                <Button
                                    {...buttonPar}
                                    title="重置" onClick={e => this.resetForm()} icon="reload">
                                    重置
                                </Button>
                                {buttons}
                            </ComponentBtnGroup>
                        </ComponentItem>
                    </ComponentCol>
                </ComponentRow>
            </Form>
        )

        return (
            <div className={cx(type === 'inline' ? styles.barDivInline : styles.barDivGrid, prefixCls, className)} {...otherProps}>
                {type === 'inline' || appendLeft ?
                    <div className={appendLeft ? styles.title : styles.titleEnd}>
                        {appendLeft ? <div className={styles.appendLeftDiv}>{appendLeft}</div> : ``}
                        {searchFields.length > 0 && type === 'inline' ? formInfo : ``}
                    </div>
                    : ``}
                {searchFields.length > 0 && type === 'grid' ?
                    <div className={styles.body}>
                        {formInfo}
                    </div>
                    : ``}
            </div>
        );
    }
}

export default createForm({ onValuesChange })(SearchBar);

function onValuesChange(props, values, allField) {
    const searchFields = props.columns.filter(col => col.searchItem && ('select' === col.searchItem.type || 'treeSelect' === col.searchItem.type))
    const searchFieldsName = searchFields.map(item => item.searchItem.name || item.name)
    for (let i = 0; i < searchFieldsName.length; i++) {
        const fieldName = searchFieldsName[i]
        if ('undefined' !== typeof values[fieldName]) {
            props.onSearch(allField)
            break;
        }
    }
}
